import React from 'react';

import { StyledAlert } from './Alert.styles';

import { AlertProps } from './Alert.types';

const Alert = ({
  children,
  typeVariant,
  componentClassname = 'alert',
  customClassnames = '',
  customStyle = '',
  ...props
}: AlertProps) => {
  return (
    <StyledAlert
      className={`${componentClassname} ${
        typeVariant ? `${componentClassname}--is-${typeVariant}` : ''
      } ${customClassnames ? customClassnames : ''}`}
      customStyle={customStyle}
      role="alert"
      {...props}
    >
      {children}
    </StyledAlert>
  );
};
Alert.displayName = 'Alert';

export default Alert;
